export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/back.4e4bdc4a.svg","height":10,"width":13,"blurWidth":0,"blurHeight":0};